// Os ficheiros CSV da pagina de analytics (RPAA-286, entrega 5 do redesign). As regras sao as do CSV do
// backend (analytics_csv.py), para os ficheiros que a pagina faz sozinha ("Descarregar esta tabela"): ponto
// e virgula e BOM, que e o que o Excel em portugues e em frances abre em colunas e com os acentos; CRLF; uma
// celula com ponto e virgula, aspas ou mudanca de linha vai entre aspas; e uma celula de texto que comeca por
// =, +, -, @, tab ou CR leva um apostrofo a frente, porque o Excel executa uma formula num CSV. Os numeros
// saem como numeros, sem formatacao: o "12,345" do ingles lia-se doze virgula tres no Excel em portugues.
const BOM = "\uFEFF";
const FORMULA_START = ["=", "+", "-", "@", "\t", "\r"];

export const neutralize = (text) => (FORMULA_START.some((start) => text.startsWith(start)) ? `'${text}` : text);

const cell = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number") return String(value);
  const text = neutralize(String(value));
  return /[;"\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// `columns` na forma do DataTable (cada uma com `key` e `label`), e cada linha com o valor em bruto de cada chave.
export const csvText = (columns, rows) =>
  BOM +
  [columns.map((column) => column.label), ...rows.map((row) => columns.map((column) => row[column.key]))]
    .map((values) => values.map(cell).join(";"))
    .join("\r\n") +
  "\r\n";

// Um nome de ficheiro a partir de um titulo: sem acentos, em minusculas, e hifens no lugar do resto.
export const fileSlug = (text) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoga depois de o download arrancar, como o FileList.
  setTimeout(() => URL.revokeObjectURL(url), 100);
};
